const EUR = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });

/** 500 → "€ 5,00" */
export const euro = (cents: number) => EUR.format(cents / 100);

/** Sends the browser to a Stripe-hosted page (checkout, onboarding, portal). */
export function goToStripe(url: string) {
  window.location.assign(url);
}
